<template>
  <div class="el-main">
    <div class="Ecard">
      <div class="testMain">
        <el-form
          :inline="true"
          size="mini"
          class="spacForm queryReport"
          :disabled="loading">
          <el-form-item label="报告名称">
            <el-select
              v-model="report_id"
              placeholder="请选择"
              class="report-name"
              @change="report_change"
            >
              <el-option
                v-for="item in smoke_lists"
                :key="item.id"
                :label="
                  item.report_name +
                  '-[' +
                  item.create_date.replace('T', ' ') +
                  ']'
                "
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-popconfirm
              @confirm="handleDelete()"
              title="确认删除该报告？"
              placement="top"
            >
              <template #reference>
                <el-button size="mini" type="info" :disabled="get_is_super">
                  <el-tooltip
                    effect="dark"
                    content="暂无管理员权限"
                    placement="top"
                    :disabled="!get_is_super"
                  >
                    <span> 删除 </span>
                  </el-tooltip>
                </el-button>
              </template>
            </el-popconfirm>
            <el-button type="primary" @click="edit = !edit" class="down_img"
              >发送报告<span
                ><img src="../../assets/down.png" alt="" /></span
            ></el-button>
          </el-form-item>
        </el-form>

        <div class="editRecipient" v-if="edit">
          <el-form
            label-position="left"
            label-width="100px"
            :model="formMail"
            size="mini">
            <el-form-item label="邮件标题">
              <el-input v-model="formMail.title"></el-input>
            </el-form-item>
            <el-form-item label="邮件发件人">
              <el-tooltip placement="bottom">
                <template #content>
                  指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人{{
                    formMail.Sender
                  }}
                </template>
                <el-input v-model="formMail.Sender"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="邮件收件人">
              <el-tooltip placement="bottom">
                <template #content>
                  可按如下任一形式批量添加：
                  <br />1、zhangsan;lisi;wangwu
                  <br />2、zhangsan(张三);lisi(李四);wangwu(王五)
                  <br />3、zhangsan(张三)
                  &lt;zhangsan@tencent.com&gt;;lisi(李四)
                  &lt;lisi@tencent.com&gt;; wangwu(王五)
                  &lt;wangwu@tencent.com&gt;
                </template>
                <el-input v-model="formMail.addressee"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="邮件抄送人">
              <el-input v-model="formMail.CC_List"></el-input>
            </el-form-item>
            <el-popconfirm
              title="确认发送报告吗？"
              @confirm="save_report(false)"
              placement="top"
            >
              <template #reference>
                <el-button
                  type="primary"
                  :disabled="get_is_super"
                  size="mini"
                >
                  <el-tooltip
                    effect="dark"
                    content="暂无管理员权限"
                    placement="top"
                    :disabled="!get_is_super"
                  >
                    <span>发送报告</span>
                  </el-tooltip>
                </el-button>
              </template>
            </el-popconfirm>
            <el-button size="mini" type="info" @click="edit = false"
              >取消</el-button
            >
          </el-form>
        </div>

        <!-- 版心 -->
        <div id="perf_report">
          <!-- 标题 -->
          <div class="spacName" v-loading="loading">
            <img
              class="banner"
              src="../../assets/performance/auto_test_banner.png"
              alt
            />
          </div>

          <!-- 报告内容 -->
          <div class="mainContent">
            <div class="spacName">
              <table class="gameTable" v-loading="loading">
                <tr>
                  <td :rowspan="3" class="gameIcon">
                    <img :src="smokeReport?.base?.project_icon" />
                  </td>
                  <td :colspan="4" class="game_name">
                    <span>【</span>{{ smokeReport?.base.project_name
                    }}<span>】</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    版本:
                    <span>
                      {{ smokeReport?.base.version }}
                    </span>
                  </td>
                  <td :colspan="2">
                    安装文件:
                    <span>{{ smokeReport?.base.filename }}</span>
                  </td>
                  <td>
                    开始测试:
                    <span>
                      {{ smokeReport?.base.start_time }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    测试结果:
                    <span
                      ><b
                        :style="{
                          color:
                            smokeReport?.base.status === '失败'
                              ? 'red'
                              : '#00b050',
                        }"
                        >{{ smokeReport?.base.status }}</b
                      >
                    </span>
                  </td>
                  <td>
                    测试类型:
                    <span>道具遍历自动化测试</span>
                  </td>
                  <td>
                    测试机型:
                    <span>{{ smokeReport?.base.model_name }}</span>
                  </td>
                  <td>
                    结束测试:
                    <span>{{ smokeReport?.base.end_time }}</span>
                    <!-- <span>01月性能版本NA;01月dev版本1.0.30.13433</span> -->
                  </td>
                </tr>
              </table>
            </div>

            <!-- 测试结论 -->
            <div class="corePerformance spacName" v-loading="loading">
              <h5 class="TitleStyle"><span></span>测试结论</h5>
              <div class="corePerformance-list">
                <div v-for="(item, index) in smoke_List" :key="index">
                  <p
                    :style="
                      'color:' +
                      (index == smoke_List.length - 1
                        ? parseFloat(item.num) / 100 < 0.8
                          ? 'red'
                          : '#00b050'
                        : '')
                    "
                  >
                    {{ item.num }}
                  </p>
                  <p>{{ item.name }}</p>
                </div>
              </div>
            </div>

            <div class="corePerformance spacName">
              <h5 class="TitleStyle"><span></span>道具遍历覆盖情况</h5>

              <div>{{ smokeReport?.props_overview?.item_desc }}</div>
              <el-table :data="overTableData" class="mt-1" border>
                <el-table-column width="" prop="道具类别" label="道具类别">
                </el-table-column>
                <el-table-column width="" prop="Equipment" label="装备">
                </el-table-column>
                <el-table-column width="" prop="Avatar" label="时装">
                </el-table-column>
                <el-table-column width="" prop="Stackable" label="可堆叠">
                </el-table-column>
                <el-table-column width="" prop="Creature" label="宠物">
                </el-table-column>
                <el-table-column width="" prop="CreatureArtifact" label="宠物装备">
                </el-table-column>
                <el-table-column width="" prop="Emblem" label="徽章">
                </el-table-column>
                <el-table-column width="" prop="MonsterCard" label="怪兽卡片">
                </el-table-column>
                <el-table-column width="" prop="Title" label="称号">
                </el-table-column>
                <el-table-column width="" prop="Skin" label="装饰">
                </el-table-column>
              </el-table>
            </div>

            <div class="mb-4 pb-3">
              <h5 class="TitleStyle" style="color: red"><span></span>失败Case列表</h5>
              <el-table
                v-if="smokeReport?.failed_case_list?.length"
                size="mini"
                :data="smokeReport?.failed_case_list"
                :header-cell-style="{
                  background: '#CCCCCC',
                  color: 'black',
                }"
                border>
                <el-table-column label="case名">
                  <template #default="scope">
                    <span>{{ scope.row.case_desc }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="所属系统">
                  <template #default="scope">
                    <span>{{ scope.row.item_type }}</span>
                  </template>
                </el-table-column>

                <el-table-column width="" label="上发协议">
                  <template #default="scope">
                    <span
                      v-if="!scope.row.is_case"
                      >{{ scope.row.case_name }}</span
                    >
                    <div
                      v-else
                    >
                      <div>{{ scope.row.case_name }}</div>
                      <div>{{ scope.row.send_data }}</div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column width="" label="校验协议">
                  <template #default="scope">
                    <span
                      v-if="!scope.row.is_check"
                      >{{ scope.row.check_protocol_name }}</span
                    >
                    <div
                      v-else
                    >
                      <div>{{ scope.row.check_protocol_name }}</div>
                      <div>{{ scope.row.check_data }}</div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column width="400" label="异常道具ID">
                  <template #default="scope">
                    <span
                      :style="'color:' + (scope.row.fail_id ? 'red' : '')"
                      >{{ scope.row.fail_id }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column width="400" label="异常原因">
                  <template #default="scope">
                    <span
                      :style="'color:' + (scope.row.fail_resason ? 'red' : '')"
                      >{{ scope.row.fail_resason }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="spacName" v-loading="loading">
              <h5 class="TitleStyle"><span></span>详细测试结果</h5>
              <div v-for="(item, i, index) in all_case_list" :key="index">
                <span style="color;#5D99D5;font-weight:bold">{{ i }}</span>
                <el-table
                  border
                  :span-method="(params) => spanMethod(params, item)"
                  size="mini"
                  :data="item.case_list"
                  :header-cell-style="{
                    background: '#5D99D5',
                    color: '#fff',
                  }">
                  <el-table-column label="Case名">
                    <template #default="scope">
                      <span
                        v-if="!scope.row.case_protocol_id"
                        :style="
                          'color:' +
                          (scope.row.check_result == 1 ? '#00b050' : 'red')
                        "
                      >
                        {{ scope.row.case_desc }}
                      </span>
                      <span v-else>{{ scope.row.case_desc }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" label="上发ID数量">
                    <template #default="scope">
                      <span>{{ scope.row.send_id_num }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="指定值">
                    <template #default="scope">
                      <span>{{ scope.row.send_params }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="校验协议">
                    <template #default="scope">
                      <span>{{ scope.row.check_protocol_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="检查值">
                    <template #default="scope">
                      <span>{{ scope.row.check_params }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="执行结果">
                    <template #default="scope">
                      <span
                        :style="
                          'color:' +
                          (scope.row.check_result == 1 ? '#00b050' : 'red')
                        "
                        >{{ scope.row.run_desc }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="执行时间">
                    <template #default="scope">
                      {{ scope.row.run_time }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <img src="../../assets/performance/footer.png" alt />
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue'
import axios from 'axios'
import {useRoute, useRouter} from 'vue-router'
import { ElMessage } from "element-plus";

async function getReports() {
  const {data} = await axios(`report/props_reports/?project=${route.query.project}`)
  smoke_lists.value = data

  const reportId = data[0].id
  report_id.value = reportId
  router.push({query: {...route.query, report_id: reportId}})
  formMail.value.title = data[0].report_name

  await getReportData(reportId)
}

async function getReportData(report_id) {
  const {project} = route.query
  if (!report_id) report_id = route.query.report_id
  const {data} = await axios(`report/props_report/?project=${project}&report_id=${report_id}`)
  smokeReport.value = data.data
}

async function handleDelete() {
  loading.value = true;

  const {project, report_id} = route.query
  await axios.delete(`report/props_report_detail/${report_id}/?project=${project}`)
  await getReports()

  loading.value = false;
}

function sendOut() {
  console.log('1')
}

async function report_change(reportId) {
  loading.value = true;
  router.push({
    query: { ...route.query, report_id: report_id.value },
  });

  formMail.value.title = smoke_lists.value.find(
    item => item.id == reportId
  )?.report_name;

  await getReportData()
  loading.value = false;
}

async function save_report() {
  const {project, report_id} = route.query
  let upload_data = null;

  if (
    project == 34 ||
    project == 40 ||
    project == 47
  ) {
    formMail.value.Sender == "febechen@tencent.com";
  } else if (project == 37) {
    formMail.value.Sender == "ethanli@tencent.com";
  }
  upload_data = {
    project: Number(project),
    report_id: Number(report_id),
    title: formMail.value.title,
    recv: formMail.value.addressee,
    cc: formMail.value.CC_List,
    send: formMail.value.Sender,
  };

  ElMessage({
    //Message 消息提示
    message: "报告发送中...",
    showClose: true,
  });
  axios.post('report/props_report/', upload_data)

  edit.value = false;
}

function toggleData(scope) {
  // 直接修改 is_case 的状态
  scope.row.is_case = !scope.row.is_case;
}

function toggleDataCheck(scope) {
  // 直接修改 is_case 的状态
  scope.row.is_check = !scope.row.is_check;
}

function spanMethod({ row, column, rowIndex, columnIndex }, item) {
  const caseListLength = item.case_list.length;

  // 判断是否为最后一行
  if (rowIndex === caseListLength - 1) {
    if (columnIndex === 0) {
      // 合并第一列 (Case名) 并显示内容
      return [1, 8]; // 合并所有列
    } else {
      // 隐藏其他列
      return [0, 0];
    }
  }
}

const route = useRoute(),
  router = useRouter()
let loading = ref(false),
  smoke_lists = ref([]),
  report_id = ref(null),
  get_is_super = ref(false),
  edit = ref(false),
  formMail = ref({
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  }),
  smokeReport = ref({
    base: {}
  }),
  all_case_list = computed(() => {
    let obj = {};
    const allCase = smokeReport.value?.all_case

    if (allCase) {
      obj = JSON.parse(JSON.stringify(allCase));
      for (let i in obj) {
        obj[i].case_list.push({
          case_desc: obj[i].desc,
          check_result: obj[i].check_result,
        });
      }
    }

    return obj;
  }),
  smoke_List = computed(() =>{
    let list = [];
    list = [
      { num: smokeReport.value?.overview?.all_protocol_num, name: "协议数" },
      { num: smokeReport.value?.overview?.all_case_num, name: "Case总数" },
      { num: smokeReport.value?.overview?.succ_case_num, name: "通过Case数" },
      { num: smokeReport.value?.overview?.fail_case_num, name: "失败Case数" },
      { num: smokeReport.value?.overview?.case_pass_rate, name: "Case通过率" },
    ];

    return list;
  }),
  overTableData = computed(() => {
    return smokeReport.value?.props_overview?.list
  })

getReports()
</script>

<style scoped>
a {
  color: #32c4f6;
  text-decoration: none;
}
.Ecard {
  width: 1260px;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 2px 10px rgb(179 186 220 / 40%);
  font-size: 14px;
}
.Ecard .testMain {
  padding: 30px;
}
.Ecard .banner {
  width: 100%;
}
/* 版本 */
.versionGeneration2 {
  display: flex;
  justify-content: space-between;
}
.versionGeneration p {
  margin-top: 10px !important;
  line-height: 32px;
}
.versionGeneration .copyVal {
  display: flex;
  justify-content: end;
  height: 28px;
}
.mainContent {
  width: 97%;
  margin: 0 auto;
}
/* 核心指标风险详情表格 */
.gameTable {
  width: 100%;
  background-color: #f5f7fa;
  border: 1px solid #e2e7eb;
  border-collapse: collapse;
  font-size: 13px;
}
.gameTable .gameIcon {
  width: 93px;
  text-align: center;
}
.gameTable .gameIcon img {
  width: 95%;
}
.gameTable span {
  font-weight: normal;
}
.gameTable td {
  border: 1px solid #e2e7eb;
  height: 31px;
  white-space: nowrap;
  font-weight: bold;
}
.gameTable tr:nth-of-type(n + 2) td {
  text-indent: 8px;
}

.gameTable .game_name,
.gameTable .com_risk_green,
.gameTable .com_risk_red {
  font-weight: bold;
}
.gameTable .com_risk_red {
  color: red;
}
.gameTable .com_risk_green {
  color: #00b050;
}

/* 底部 */
.footer {
  background-color: #eff4fa;
  width: 100%;
  height: 31px;
  text-align: center;
}

/* 测试结论 */

.corePerformance p.spacName,
.corePerformance h6 {
  font-weight: bold !important;
  font-size: 15px;
  margin-top: 10px;
  vertical-align: middle;
}
.corePerformance-list {
  display: flex;
  justify-content: space-around;
  background: #f2f2f2;
  height: 100px;
  align-items: center;
  text-align: center;
  border: 1px solid #e2e7eb;
}
.corePerformance-list div {
  width: 100%;
}
.corePerformance-list div p:nth-child(1) {
  font-size: 30px;
  font-weight: bold;
  margin: 0 !important;
}
.corePerformance-list div p:nth-child(2) {
  font-size: 18px;
}
.corePerformance-list div {
  height: 100%;
  border-left: 1px solid #e2e7eb;
  border-right: 1px solid #e2e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.corePerformance-list div:nth-child(3) p:nth-child(1) {
  color: #00b050;
}
.corePerformance-list div:nth-child(4) p:nth-child(1) {
  color: red;
}
.corePerformance p {
  margin-bottom: 10px !important;
  text-indent: 1rem;
}
.TestConclusionTable .scene {
  text-align: left;
}
.TestConclusionTable .green {
  color: #41c486;
}
.TestConclusionTable .red {
  color: #ff485b;
}

/* 内存性能趋势 */
.TrendChart p {
  margin-bottom: 10px !important;
}
/* 性能数据 */
.performanceData .gray {
  background-color: #95a5a6;
}
.performanceData .performanceTitle {
  margin: 10px 0 !important;
  text-indent: 0;
  font-weight: bold !important;
}
.performanceTable td,
.corePerformance th {
  border: 1px solid #d9d9d9;
  padding: 0 2px;
}
.corePerformance th {
  background-color: #5b9bd5;
  color: white;
  text-align: center;
  font-weight: 550;
}
.obj_type {
  white-space: pre-line !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
}
.performanceTable td {
  text-align: right;
}
.performanceTable .gray_ {
  background-color: #cecece;
}
.performanceTable .pink {
  background-color: red;
}
.performanceTable .pink2 {
  background-color: orange;
}
.performanceTable .pink3 {
  background-color: #fee1e2;
}
.performanceTable .pink4 {
  border-color: #fffdfd;
}
.performanceTable .green {
  background-color: rgb(4, 158, 4);
}
.performanceTable .green2 {
  background-color: #cae9d2;
}
.performanceTable .green3 {
  background-color: #00b050;
}
.performanceTable .red {
  background-color: #ff0000;
}
.performanceTable .LINK td {
  text-align: center;
}
.performanceTable .size-quantity th {
  text-align: left;
}
/* FPS趋势图 */
.FPStrend {
  margin-bottom: 20px;
  /*height: 350px;*/
}
.gameTable2 {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.gameTable2 td {
  border: 1px solid #d9d9d9;
  text-align: center;
}
.gameTable2 thead {
  background: rgb(93, 153, 213);
}
.gameTable2 thead td {
  color: #fff;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}
.gameTable2 thead td:last-child {
  width: 460px;
}


.report-name {
  width: 546px;
}

.editRecipient .el-form-item {
  margin-bottom: 15px !important;
}
</style>
